// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import type { Fetcher, FetcherResults } from '@ta/common.typeahead';
import type { GeoPillSponsorData, GeoPillSponsorDataProvider } from '@ta/brand.sponsored-geopill';

/** The fetcher ID */
export const ID = 'sponsoredgeo';

/**
 * A fetcher for sponsored geos.
 *
 * Fetches sponsored geo data. This is currently in testing, and thus just returns one of several hardcoded answers.
 * @author mholland
 * @since July 2019
 */
class SponsoredGeoFetcher implements Fetcher {
  id: string = ID;
  sponsorData: GeoPillSponsorData | null;
  onChange: () => mixed | null;

  constructor(sponsorDataProvider: GeoPillSponsorDataProvider) {
    sponsorDataProvider((sponsorData: GeoPillSponsorData) => {
      this.sponsorData = sponsorData;

      if (this.onChange) {
        this.onChange();
      }
    });
  }

  getResults(): FetcherResults {
    if (this.sponsorData) {
      const {
        name,
        location_id: locationId,
        ancestors,
        dfpTrackingUrl,
        thirdPartyClickTrackerURL,
      } = this.sponsorData;

      const result = {
        name,
        location_id: locationId,
        ancestors: ancestors ? ancestors.map(parent => ({ name: parent })) : [],
        dfpTrackingUrlTemplate: dfpTrackingUrl ? `${dfpTrackingUrl}\${destUrl}` : null,
        thirdPartyClickTrackerURL,
      };

      return [result];
    }

    return [];
  }

  fetch(term: string, context: ?{ [string]: any }, onChange: () => mixed): void {
    this.onChange = onChange;
    onChange();
  }
}

export default SponsoredGeoFetcher;
